export const DISMISS_CONFIRMATION = 'DISMISS_CONFIRMATION';
export type DISMISS_CONFIRMATION = typeof DISMISS_CONFIRMATION;

export const ADD_CONFIRMATION = 'ADD_CONFIRMATION';
export type ADD_CONFIRMATION = typeof ADD_CONFIRMATION;